import {mapiqApi, ParkingLocationDto, WorkspaceLocationDto} from '@lib/infrastructure';
import {createAsyncThunk} from '@reduxjs/toolkit';
import {AppThunkApiConfig} from '../..';

import {getIsParkingFeatureEnabled} from '../../infrastructure';

export const loadPreferences = createAsyncThunk<any, void, AppThunkApiConfig>(
  'preferences/getPreferences',
  async (_, {extra}) => {
    const {apiClient} = extra;
    const api = mapiqApi(apiClient);

    return await api.getPreferences();
  },
);

export const updateWorkspaceLocationPreferences = createAsyncThunk<
  WorkspaceLocationDto,
  WorkspaceLocationDto,
  AppThunkApiConfig
>('workspace/updateWorkspaceLocationPreferences', async (preferences: WorkspaceLocationDto, {extra}) => {
  const client = extra.apiClient;
  const api = mapiqApi(client);

  return await api.putWorkspacePreferences(preferences);
});

export const updateParkingLocationPreferences = createAsyncThunk<
  ParkingLocationDto,
  ParkingLocationDto,
  AppThunkApiConfig
>('workspace/updateParkingLocationPreferences', async (preferences: ParkingLocationDto, {extra}) => {
  const client = extra.apiClient;
  const api = mapiqApi(client);

  return await api.putParkingPreferences(preferences);
});

// Parking
export const dismissParkingSuggestionPopUp = createAsyncThunk<void, void, AppThunkApiConfig>(
  'preferences/dismissParkingSuggestionPopUp',
  async (_, {extra, getState}) => {
    if (!getIsParkingFeatureEnabled(getState())) {
      return;
    }
    const {apiClient} = extra;
    const api = mapiqApi(apiClient);
    await api.patchWorkspaceReservationPreferences({userDismissedParkingSuggestionPopUp: true});
  },
);

export const dismissParkingIntroduction = createAsyncThunk<void, void, AppThunkApiConfig>(
  'preferences/dismissParkingIntroduction',
  async (_, {extra, getState}) => {
    if (!getIsParkingFeatureEnabled(getState())) {
      return;
    }
    const {apiClient} = extra;
    const api = mapiqApi(apiClient);
    await api.patchWorkspaceReservationPreferences({userDismissedParkingIntroduction: true});
  },
);

export const updateLicensePlate = createAsyncThunk<string | null, string, AppThunkApiConfig>(
  'preferences/updateLicensePlate',
  async (licensePlate, {extra}) => {
    const {apiClient} = extra;
    const api = mapiqApi(apiClient);
    const {preferences} = await api.patchWorkspaceReservationPreferences({licensePlate});

    return preferences.parking_LicensePlate;
  },
);

export const updateLicensePlates = createAsyncThunk<string[] | null, string[], AppThunkApiConfig>(
  'preferences/updateLicensePlates',
  async (licensePlates, {extra}) => {
    const {apiClient} = extra;
    const api = mapiqApi(apiClient);
    const {preferences} = await api.patchWorkspaceReservationPreferences({licensePlates});

    return preferences.parking_LicensePlates;
  },
);

export const updateThreeDMapsPreferred = createAsyncThunk<boolean, boolean, AppThunkApiConfig>(
  'preferences/updateThreeDMapsPreferred',
  async (threeDMapsPreferred, {extra}) => {
    const {apiClient} = extra;
    const api = mapiqApi(apiClient);
    const {preferences} = await api.patchWorkspaceReservationPreferences({threeDMapsPreferred});

    return preferences.threeDMapsPreferred;
  },
);
